module.exports = __webpack_public_path__ + "img/move_gently.234faad4.svg";